export default __webpack_public_path__ + "static/char-s-05-chs-24d786c742b3b62c53bb2712fbea1e84.webp";